import { jsxs as M, jsx as _ } from "react/jsx-runtime";
import { useRef as A, useState as N, useMemo as v, useCallback as w, useEffect as D } from "react";
import { V as k } from "./index-CeQ14xPc.js";
import { c as H } from "./clsx-OuTLNxxd.js";
import { B as V } from "./Button-B2Q9lfS-.js";
import './TableScrollContainer.css';const x = 600, I = ({ cellWidth: C, maxRows: p }) => {
  const d = A(null), [a, c] = N(0), [W, T] = N(!1), [l, B] = N({
    pinCount: 0,
    rowCount: 0,
    headings: null
  }), [S, g] = N({
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  }), e = v(
    () => S.left || S.right,
    [S.left, S.right]
  ), i = w(() => {
    if (!d.current) return null;
    const t = d.current.querySelector("table"), o = d.current.getElementsByTagName("thead")[0], n = d.current.getElementsByTagName("tbody")[0], u = d.current.getElementsByTagName("tfoot")[0];
    if (!t || !o) return null;
    const s = o.getElementsByTagName("th");
    return s.length ? { container: d.current, table: t, headings: s, tbody: n, tfoot: u } : null;
  }, []), h = w(() => {
    var m;
    const t = i();
    if (!t) return;
    const { headings: o, tbody: n } = t, u = ((m = n == null ? void 0 : n.getElementsByTagName("tr")) == null ? void 0 : m.length) || 0, s = W ? 0 : [...o].filter((b) => b.dataset.pinned === "true").length;
    B({
      pinCount: s,
      rowCount: u,
      headings: o
    });
  }, [i, W]), y = w(() => {
    const t = i();
    if (!t) return { left: !1, right: !1 };
    const { container: o, table: n } = t, u = o.clientWidth, s = n.clientWidth, m = a >= 0, b = a <= -(s - u);
    return {
      left: !m,
      right: !b && s > u
    };
  }, [a, i]), E = w(() => {
    if (!l.headings)
      return { top: !1, bottom: !1 };
    const t = i();
    if (!t || !t.tbody || !t.tfoot)
      return { top: !1, bottom: !1 };
    const { tbody: o, tfoot: n } = t, u = l.headings[0].getBoundingClientRect().bottom, s = n.getBoundingClientRect().top, m = o.getBoundingClientRect().top, b = o.getBoundingClientRect().bottom;
    return {
      top: m < u,
      bottom: b > s
    };
  }, [i, l.headings]), f = w(
    (t = !1) => {
      const o = y();
      if (t) {
        const n = E();
        g({
          ...o,
          ...n
        });
      } else
        g((n) => ({
          ...n,
          ...o
        }));
    },
    [y, E]
  ), z = w(
    (t) => {
      const o = i();
      if (!o) return;
      const { container: n, table: u } = o, s = n.clientWidth, m = u.clientWidth, b = Math.max(0, m - s), F = t === "left" ? Math.min(0, a + C) : Math.max(-b, a - C);
      c(F), f();
    },
    [C, f, a, i]
  );
  return D(() => {
    T(window.innerWidth <= x), h();
    const t = !!p && !!l.rowCount && p < l.rowCount;
    f(t);
    const o = () => {
      T(window.innerWidth <= x), h(), f(!!p);
    };
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, [p, f, h, l.rowCount]), {
    scrollRef: d,
    currentTransform: a,
    scrollDirection: S,
    shouldShowScrollButtons: e,
    pinCount: l.pinCount,
    onScrollClick: z,
    checkScroll: f,
    rowCount: l.rowCount
  };
}, L = "_wrapper_14tiv_32", j = "_captionWrapper_14tiv_41", O = "_caption_14tiv_41", $ = "_buttonWrapper_14tiv_58", q = "_button_14tiv_58", K = "_innerWrapper_14tiv_72", P = "_hasMaxHeight_14tiv_78", X = "_hasScrollShadowEnd_14tiv_82", G = "_hasScrollShadowStart_14tiv_91", J = "_hasScrollShadowTop_14tiv_100", Q = "_hasScrollShadowBottom_14tiv_109", R = "_hasVerticalScroll_14tiv_126", U = "_hasHorizontalScroll_14tiv_130", Y = "_scrollFullWidth_14tiv_134", r = {
  wrapper: L,
  captionWrapper: j,
  caption: O,
  buttonWrapper: $,
  button: q,
  innerWrapper: K,
  hasMaxHeight: P,
  hasScrollShadowEnd: X,
  hasScrollShadowStart: G,
  hasScrollShadowTop: J,
  hasScrollShadowBottom: Q,
  hasVerticalScroll: R,
  hasHorizontalScroll: U,
  scrollFullWidth: Y
}, rt = ({
  caption: C,
  cellWidth: p = 60,
  children: d,
  className: a,
  maxRows: c,
  ...W
}) => {
  const {
    checkScroll: T,
    currentTransform: l,
    onScrollClick: B,
    pinCount: S,
    rowCount: g,
    scrollDirection: e,
    scrollRef: i,
    shouldShowScrollButtons: h
  } = I({
    maxRows: c,
    cellWidth: p
  }), y = v(
    () => H(
      r.wrapper,
      {
        [r.hasScrollShadowTop]: e.top,
        [r.hasScrollShadowBottom]: e.bottom,
        [r.scrollFullWidth]: !e.left || !h,
        [r.hasVerticalScroll]: e.top || e.bottom,
        [r.hasHorizontalScroll]: e.left || e.right
      },
      a
    ),
    [a, e, h]
  ), E = v(
    () => H(r.innerWrapper, {
      [r.hasMaxHeight]: c,
      [r.hasScrollShadowEnd]: h && e.right,
      [r.hasScrollShadowStart]: h && e.left
    }),
    [c, h, e.right, e.left]
  ), f = v(
    () => ({
      "--maxRows": g && c && g < c ? g : c,
      "--cellWidth": `${p}px`,
      "--pinCount": S
    }),
    [p, c, S, g]
  ), z = v(
    () => ({
      "--table-horizontal-offset": `translateX(${l}px)`
    }),
    [l]
  );
  return /* @__PURE__ */ M("div", { className: y, style: f, ...W, children: [
    /* @__PURE__ */ M("div", { className: r.captionWrapper, children: [
      /* @__PURE__ */ _("h2", { className: r.caption, children: C }),
      h && /* @__PURE__ */ M("div", { className: r.buttonWrapper, "data-testid": "scroll-controls", children: [
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table left",
            className: r.button,
            disabled: !e.left,
            onClick: () => B("left"),
            variant: "ghost",
            children: /* @__PURE__ */ _(k, { size: "s" })
          }
        ),
        /* @__PURE__ */ _(
          V,
          {
            "aria-label": "scroll table right",
            className: r.button,
            disabled: !e.right,
            onClick: () => B("right"),
            variant: "ghost",
            children: /* @__PURE__ */ _(k, { size: "s" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ _(
      "div",
      {
        className: E,
        onScroll: () => T(!!c),
        ref: i,
        style: z,
        children: d
      }
    )
  ] });
};
export {
  rt as T
};
